import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RdsChipsModule } from '@rds/angular-components';

/**
 * A wrapping row of starter prompts shown next to the "Ask Panorama" field.
 *
 * Purely presentational — it emits the chosen prompt and lets the parent decide
 * where that leads (the hero searches, the search-results widget opens the
 * chat).
 *
 * Built on `RdsChipComponent` applied to `<button>`, which its selector
 * supports: the styling comes from the design system, and the element stays a
 * real button because these chips are actions a keyboard user must be able to
 * fire.
 */
@Component({
  selector: 'inexp-prompt-chips',
  imports: [RdsChipsModule],
  templateUrl: './prompt-chips.component.html',
  styleUrl: './prompt-chips.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromptChipsComponent {
  /** Prompts to offer, in display order. */
  readonly prompts = input<readonly string[]>([]);

  /** Accessible name for the group, e.g. "Suggested questions". */
  readonly label = input<string>('Suggested questions');

  /** Emits the prompt text the user picked. */
  readonly promptSelected = output<string>();
}
